import { Component, OnInit, Optional, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { MatDialogRef, MAT_DIALOG_DATA, SimpleSnackBar, MatSnackBar } from '@angular/material';
import { Http } from '@angular/http';
import { environment } from '../../environments/environment';


@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {

    private url: string = environment.apiUrl;
    private headers = new Headers({ 'Content-Type': 'application/json' });

    public sendingMessage = false;

    constructor(
        private http: Http,
        private snackBar: MatSnackBar,
        @Optional() public dialogRef: MatDialogRef<ContactComponent>
    ) { }

    ngOnInit() {

    }


    public onSubmit(value: any) {

        if (value.email === '') {
            this.snackBar.open('Please add an email address!', '', {
                duration: 3000,
              });
        }else if (value.message === '') {
            this.snackBar.open('Please add a message for us to read!', '', {
                duration: 3000,
              });
        }else {

            this.sendingMessage = true;

            this.http
            .post(`${this.url}/contact`, { 'details': value})
            .subscribe(
            res => {
                this.snackBar.open('Your message has been sent to us!', '', {
                    duration: 3000,
                });
                this.dialogRef.close();
                this.sendingMessage = false;
            },
            error => {
                this.sendingMessage = false;

                this.snackBar.open(error._body, '', {
                    duration: 3000,
                });
            });
        }
    }

}







// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/mmam/angular/src/app/contact/contact.component.ts